import { useState } from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import type { LinkedCategory } from '@storefront/lib-global/codegen/types';
import { useMediaMatch } from '@storefront/lib-global/hooks/useMediaMatch';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global/stylings';

const S = {
  QuickLinksContainer: styled.div`
    display: flex;
    gap: ${spacing.S};
    -ms-overflow-style: none;
    overflow-x: scroll;
    padding: ${spacing.S} ${spacing.S} ${spacing.XXS} ${spacing.S};
    scrollbar-width: none;
    width: calc(100vw - 24px);
    @media ${media.greaterThan('lg')} {
      flex-direction: column;
      gap: ${spacing.S};
      max-width: 302px;
      overflow-x: visible;
      padding: 0;
      width: auto;
    }
  `,
  Quicklinks: styled.a`
    ${TypographyStyles.CallToAction.Large.SemiBold}
    color: ${colours.BLACK};
    text-decoration-line: underline;
    white-space: nowrap;
    @media ${media.greaterThan('lg')} {
      white-space: normal;
    }
  `,
  Showlinks: styled.button`
    all: unset;
    ${TypographyStyles.CallToAction.Large.SemiBold}
    cursor: pointer;
    text-decoration-line: underline;
    white-space: nowrap;

    &:focus-visible {
      outline: 2px solid ${colours.OUTLINE_BORDER};
    }
  `,
  Divider: styled.hr`
    display: none;
    margin: ${spacing.M} 0px 0px;
    padding: 0px;
    width: 302px;
    @media ${media.greaterThan('lg')} {
      display: block;
    }
  `,
};

function LinkedCategories({ displayedLinks }: { displayedLinks?: LinkedCategory[] }) {
  if (!displayedLinks) return null;
  return (
    <>
      {displayedLinks.map((link) => (
        <Link key={link.key} href={`/${link.key}-c`} passHref>
          <S.Quicklinks>{link.name}</S.Quicklinks>
        </Link>
      ))}
    </>
  );
}
export function QuickLinks({
  linkedCategories,
  initialQuickLinks,
}: {
  linkedCategories?: LinkedCategory[];
  initialQuickLinks: number;
}) {
  const [showLinks, setShowLinks] = useState(false);
  const isDesktop = useMediaMatch(media.greaterThan('lg'));
  const displayedLinks = showLinks ? linkedCategories : linkedCategories?.slice(0, initialQuickLinks);
  return (
    <>
      <S.QuickLinksContainer data-testid="quickLinksContainer">
        {isDesktop ? (
          <>
            <LinkedCategories displayedLinks={displayedLinks} />
            {(linkedCategories?.length || 0) > initialQuickLinks && (
              <S.Showlinks onClick={() => setShowLinks(!showLinks)}>{showLinks ? '- Less' : '+ More'}</S.Showlinks>
            )}
          </>
        ) : (
          <LinkedCategories displayedLinks={linkedCategories} />
        )}
      </S.QuickLinksContainer>
      <S.Divider />
    </>
  );
}
